// extracted by mini-css-extract-plugin
export default {"orderTable":"OrderItems_orderTable__Ijbfu","orderItems":"OrderItems_orderItems__eBOuS","itemsBlock":"OrderItems_itemsBlock__JqI-K","total":"OrderItems_total__mIYbG"};